import React from 'react';
import './Modal.css';

// Define the announcement content
const latestAnnouncement = {
  id: 4,
  title: 'We Value Your Feedback!',
  content: (
    <div>
      <p>
        The chatbot is still in its pilot phase, and your feedback is essential to help us improve and ensure the answers are helpful.
      </p>
      <h3>How Can You Help?</h3>
      <ul>
        <li>
          <strong>Rate the Answers:</strong> Use the thumbs up or down buttons to let us know if the response was helpful.
        </li>
        <li>
          <strong>Provide Feedback:</strong> Use the text box to share your thoughts on the response or suggest how we can improve.
        </li>
      </ul>
      <p>
        Your input is incredibly important and directly contributes to making the chatbot better. Thank you for your help!
      </p>
    </div>
  ),
};

// Modal component
// dir: optional 'rtl' | 'ltr' - text direction for Hebrew/English (default: 'ltr')
const Modal = ({ isOpen, onClose, title, children, dir = 'ltr' }) => {
  if (!isOpen) return null;
  const isRtl = dir === 'rtl';

  return (
    <div className="modal-overlay">
      <div className="modal-content" dir={dir}>
        <div className={`modal-header ${isRtl ? 'modal-header--rtl' : ''}`}>
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="modal-button">Got it!</button>
        </div>
      </div>
    </div>
  );
};

export { Modal, latestAnnouncement };
